import React, { useState } from 'react'
import styled from 'styled-components'
import theme from '../../styles/theme'
import { useAuth } from './AuthProvider'

const UserMenuContainer = styled.div`
  position: relative;
  display: inline-block;
`

const UserButton = styled.button`
  background: ${theme.color.background.light};
  border: 1px solid ${theme.color.border.light};
  color: ${theme.color.text.base};
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  transition: all 0.2s ease;

  &:hover {
    background: ${theme.color.background.lightGrey};
    border-color: ${theme.color.border.light};
  }

  &:focus {
    outline: 2px solid ${theme.color.accent.primary};
    outline-offset: 2px;
  }
`

const UserAvatar = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${theme.color.accent.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 0.8rem;
`

const DropdownMenu = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  right: 0;
  background: ${theme.color.background.light};
  border: 1px solid ${theme.color.border.light};
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  z-index: 1000;
  display: ${props => props.isOpen ? 'block' : 'none'};
  margin-top: 0.5rem;
`

const DropdownHeader = styled.div`
  padding: 1rem;
  border-bottom: 1px solid ${theme.color.border.light};
`

const UserName = styled.div`
  color: ${theme.color.text.base};
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
`

const UserEmail = styled.div`
  color: ${theme.color.text.grey};
  font-size: 0.8rem;
`

const DropdownItem = styled.button`
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  background: none;
  color: ${theme.color.text.base};
  text-align: left;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s ease;

  &:hover {
    background: ${theme.color.background.lightGrey};
  }

  &:focus {
    outline: none;
    background: ${theme.color.background.lightGrey};
  }
`

const UserMenu: React.FC = () => {
  const { user, logout } = useAuth()
  const [isOpen, setIsOpen] = useState(false)

  const handleLogout = () => {
    setIsOpen(false)
    logout()
  }

  const getInitials = (name: string): string => {
    return name
      .split(' ')
      .map(part => part.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2)
  }

  if (!user) return null

  return (
    <UserMenuContainer>
      <UserButton onClick={() => setIsOpen(!isOpen)}>
        <UserAvatar>
          {getInitials(user.display_name || user.username)}
        </UserAvatar>
        {user.display_name || user.username}
        <span style={{ marginLeft: '0.25rem', fontSize: '0.7rem' }}>▼</span>
      </UserButton>

      <DropdownMenu isOpen={isOpen}>
        <DropdownHeader>
          <UserName>{user.display_name || user.username}</UserName>
          {user.email && <UserEmail>{user.email}</UserEmail>}
        </DropdownHeader>
        <DropdownItem onClick={handleLogout}>
          Sign Out
        </DropdownItem>
      </DropdownMenu>

      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999
          }}
          onClick={() => setIsOpen(false)}
        />
      )}
    </UserMenuContainer>
  )
}

export default UserMenu
